// dayjs.extend(utc);

// const AddPatientForm = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { ehrNumber } = location.state || {};

//   const [formData, setFormData] = useState({
//     ehr: ehrNumber || location.state?.ehr || "",
//     email: location.state?.email || "",
//     firstName: location.state?.firstName || "",
//     lastName: location.state?.lastName || "",
//     birthDate: location.state?.birthDate
//       ? dayjs(location.state.birthDate).utc(true).startOf("day")
//       : null,
//   });

//   const [errors, setErrors] = useState({});

//   const handleChange = (field) => (e) => {
//     const value = field === "birthDate" ? e : e.target.value;

//     if (field === "ehr") {
//       if (!/^\d{0,7}$/.test(value)) return;
//     }

//     setFormData({ ...formData, [field]: value });
//     setErrors({ ...errors, [field]: "" });
//   };

//   const validateFields = () => {
//     const newErrors = {};
//     const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
//     const nameRegex = /^[a-zA-Z0-9 ]+$/;
//     const ehrRegex = /^\d{7}$/;

//     if (!formData.ehr) newErrors.ehr = "EHR Number is required";
//     else if (!ehrRegex.test(formData.ehr))
//       newErrors.ehr = "EHR must be exactly 7 digits";

//     if (!formData.email) newErrors.email = "Email is required";
//     else if (!emailRegex.test(formData.email))
//       newErrors.email = "Invalid email format";

//     if (!formData.firstName) newErrors.firstName = "First Name is required";
//     else if (!/^[A-Za-z ]+$/.test(formData.firstName))
//       newErrors.firstName = "Only letters and spaces allowed";

//     if (!formData.lastName) newErrors.lastName = "Last Name is required";
//     else if (!/^[A-Za-z ]+$/.test(formData.lastName))
//       newErrors.lastName = "Only letters and spaces allowed";

//     if (!formData.birthDate) newErrors.birthDate = "Birth Date is required";

//     return newErrors;
//   };

//   const handleContinue = () => {
//     const validationErrors = validateFields();
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }

//     const processedFormData = {
//       ...formData,
//       birthDate: formData.birthDate
//         ? formData.birthDate.format("YYYY-MM-DD")
//         : "",
//       matchedEhr: formData.ehr,
//       patientId: formData.patientId || null,
//     };

//     localStorage.setItem("patientDraft", JSON.stringify(processedFormData));

//     navigate("/confirm-patient", { state: processedFormData });
//   };

//   return (
//     <PageLayout>
//       <Box sx={{ position: "relative", p: 2 }}>
//         <IconButton
//           onClick={() => navigate("/dashboard")}
//           sx={{ position: "absolute", top: 0, right: 0, color: "#666" }}
//         >
//           <CloseIcon />
//         </IconButton>
//       </Box>

//           <Typography
//             variant="h4"
//             sx={{
//               fontSize: "42px",
//               fontWeight: 600,
//               color: "var(--tamu-maroon)",
//               textAlign: "center",
//               mb: "45px",
//             }}
//           >
//             Add Basic Participant Information
//           </Typography>

// export default AddPatientForm;

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Stack,
  Checkbox,
  FormControlLabel,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import FocusedFlowPage from "../../../components/FocusedFlowPage";
import { BIOBANK_SUB_ROUTES } from "../../../constants/routes";
import { fetchPatientByAccountNumber } from "../../../utils/apiPatient";

const US_STATES = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];
const AddPatientForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { ehrNumber } = location.state || {};
  const flow = location.state?.flow || "schedule";
  const returnTo = location.state?.returnTo || BIOBANK_SUB_ROUTES.PARTICIPANT_SCHEDULING_VERIFY;
  const isDropIn = location.state?.isDropIn || flow === "dropIn";

  const [formData, setFormData] = useState({
    ehr: ehrNumber || location.state?.ehr || "",
    email: location.state?.email || "",
    firstName: location.state?.firstName || "",
    lastName: location.state?.lastName || "",
    birthDate: location.state?.birthDate || "",
    mobilePhoneNumber: location.state?.mobilePhoneNumber || "",
    homeAddressLine1: location.state?.homeAddressLine1 || "",
    homeAddressLine2: location.state?.homeAddressLine2 || "",
    city: location.state?.city || "",
    state: location.state?.state || "",
    zipCode: location.state?.zipCode || "",
  });

  const [errors, setErrors] = useState({});
  const [includeAddress, setIncludeAddress] = useState(
    !!(
      location.state?.homeAddressLine1 ||
      location.state?.city ||
      location.state?.state ||
      location.state?.zipCode
    ),
  );
  const [showAlert, setShowAlert] = useState(
    location.state?.showAlert || false,
  );

  useEffect(() => {
    if (showAlert) {
      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 3000); // 3 seconds

      return () => clearTimeout(timer);
    }
  }, [showAlert]);

  const handleChange = (field) => (e) => {
    let value = e.target?.value ?? e;
    if (field === "firstName" || field === "lastName") {
      // Allow only letters and spaces
      value = value.replace(/[^A-Za-z\s]/g, "");

      // Capitalize each word and lowercase the rest
      value = value.replace(
        /\b\w+\b/g,
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
      );
    }
    if (field === "email") {
      value = value.toLowerCase();
    }

    if (field === "ehr") {
      if (!/^\d{0,7}$/.test(value)) return;
    }

    if (field === "mobilePhoneNumber") {
      // Remove all non-digit characters
      const digits = value.replace(/\D/g, "");
      if (digits.length > 10) return;

      // Format as (XXX) XXX-XXXX
      if (digits.length <= 3) {
        value = digits;
      } else if (digits.length <= 6) {
        value = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
      } else {
        value = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
      }
    }

    if (field === "zipCode") {
      // Only allow 5 digits for zip code
      const digits = value.replace(/\D/g, "");
      if (digits.length > 5) return;
      value = digits;
    }

    setFormData({ ...formData, [field]: value });
    setErrors({ ...errors, [field]: "" });
  };

  const handleBirthDatePaste = (e) => {
    const pasted = e.clipboardData.getData("text").trim();
    const parsed = dayjs(
      pasted,
      ["MM/DD/YYYY", "M/D/YYYY", "MM-DD-YYYY", "M-D-YYYY", "YYYY-MM-DD"],
      true,
    );
    if (parsed.isValid()) {
      e.preventDefault();
      setFormData((p) => ({ ...p, birthDate: parsed.format("YYYY-MM-DD") }));
      setErrors((err) => ({ ...err, birthDate: "" }));
    }
  };

  const handleAddressCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIncludeAddress(checked);

    // Clear all address fields when unchecking
    if (!checked) {
      setFormData({
        ...formData,
        homeAddressLine1: "",
        homeAddressLine2: "",
        city: "",
        state: "",
        zipCode: "",
      });
      // Clear address-related errors
      setErrors({
        ...errors,
        homeAddressLine1: "",
        homeAddressLine2: "",
        city: "",
        state: "",
        zipCode: "",
      });
    }
  };

  const validateFields = () => {
    const newErrors = {};
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const ehrRegex = /^\d{7}$/;
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    const zipCodeRegex = /^\d{5}$/;

    if (!formData.ehr) newErrors.ehr = "MRN is required";
    else if (!ehrRegex.test(formData.ehr))
      newErrors.ehr = "MRN must be exactly 7 digits";

    if (!formData.email) newErrors.email = "Email is required";
    else if (!emailRegex.test(formData.email))
      newErrors.email = "Invalid email format";

    if (!formData.firstName) newErrors.firstName = "First Name is required";
    else if (!/^[A-Za-z ]+$/.test(formData.firstName))
      newErrors.firstName = "Only letters and spaces allowed";

    if (!formData.lastName) newErrors.lastName = "Last Name is required";
    else if (!/^[A-Za-z ]+$/.test(formData.lastName))
      newErrors.lastName = "Only letters and spaces allowed";

    if (!formData.birthDate) newErrors.birthDate = "Birth Date is required";

    if (!formData.mobilePhoneNumber)
      newErrors.mobilePhoneNumber = "Phone number is required";
    else if (!phoneRegex.test(formData.mobilePhoneNumber))
      newErrors.mobilePhoneNumber =
        "Phone must be 10 digits in format (XXX) XXX-XXXX";

    // Address validation - only if checkbox is checked
    if (includeAddress) {
      if (!formData.homeAddressLine1)
        newErrors.homeAddressLine1 = "Street address is required";
      if (!formData.city) newErrors.city = "City is required";
      if (!formData.state) newErrors.state = "State is required";
      if (!formData.zipCode) newErrors.zipCode = "Zip code is required";
      else if (!zipCodeRegex.test(formData.zipCode))
        newErrors.zipCode = "Zip code must be 5 digits";
    }

    return newErrors;
  };

  const handleContinue = async () => {
    const validationErrors = validateFields();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const existingPatient = await fetchPatientByAccountNumber(formData.ehr);
      if (existingPatient) {
        setErrors({ ehr: "This MRN already exists" });
        return;
      }
    } catch (error) {
      console.error("Error checking patient uniqueness:", error);
    }

    const processedFormData = {
      ...formData,
      birthDate: formData.birthDate,
      matchedEhr: formData.ehr,
      patientId: formData.patientId || null,
      flow,
      returnTo,
      isDropIn,
    };

    localStorage.setItem("patientDraft", JSON.stringify(processedFormData));

    if (flow === "dropIn") {
      // For Drop In, we skip the long wizard and use the same streamlined flow as Schedule
      navigate(BIOBANK_SUB_ROUTES.PARTICIPANT_SCHEDULING_CONFIRM, { state: processedFormData });
    } else {
      navigate(BIOBANK_SUB_ROUTES.PARTICIPANT_SCHEDULING_CONFIRM, { state: processedFormData });
    }
  };

  return (
    <FocusedFlowPage
      title="Add Basic Participant Information"
      onClose={() => navigate(returnTo)}
      maxWidth={760}
      alert={
        showAlert ? (
          <Alert
            icon={<ErrorOutlineIcon sx={{ color: "white" }} />}
            severity="error"
            sx={{
              backgroundColor: "#c62828",
              color: "#fdecea",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
              padding: "10px 18px",
              fontWeight: 600,
              fontSize: "15.5px",
              textAlign: "auto",
              maxWidth: "400px",
              mx: "auto",
            }}
          >
            No Participant Medical Record Number Found!
          </Alert>
        ) : null
      }
      actions={[
        <Button
          key="back"
          variant="outlined"
          onClick={() =>
            navigate(BIOBANK_SUB_ROUTES.PARTICIPANT_SCHEDULING_VERIFY, { state: { flow, returnTo } })
          }
          sx={{
            borderRadius: 0,
            borderColor: "#B28F38",
            color: "var(--tamu-maroon)",
            fontWeight: 600,
            fontSize: "14px",
            "&:hover": {
              backgroundColor: "#fff8e1",
              borderColor: "#B28F38",
            },
          }}
        >
          ← BACK
        </Button>,
        <Button
          key="continue"
          variant="contained"
          onClick={handleContinue}
          sx={{
            backgroundColor: "var(--tamu-maroon)",
            borderRadius: 0,
            fontWeight: 600,
            fontSize: "14px",
            "&:hover": {
              backgroundColor: "var(--tamu-maroon)",
            },
          }}
        >
          CONTINUE →
        </Button>,
      ]}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box sx={{ maxWidth: "700px", margin: "0 auto", padding: "0rem 0" }}>
          <Stack spacing={2}>
            <Field
              label="Participant MRN"
              required
              value={formData.ehr}
              onChange={handleChange("ehr")}
              error={errors.ehr}
            />

            <Field
              label="First Name"
              required
              value={formData.firstName}
              onChange={handleChange("firstName")}
              error={errors.firstName}
            />
            <Field
              label="Last Name"
              required
              value={formData.lastName}
              onChange={handleChange("lastName")}
              error={errors.lastName}
            />
            <Field
              label="Phone Number"
              required
              value={formData.mobilePhoneNumber}
              onChange={handleChange("mobilePhoneNumber")}
              error={errors.mobilePhoneNumber}
            />
            <Field
              label="Participant E-Mail"
              required
              value={formData.email}
              onChange={handleChange("email")}
              error={errors.email}
              type="email"
            />

            <Box sx={{ mt: 3, mb: 1 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={includeAddress}
                    onChange={handleAddressCheckboxChange}
                    sx={{
                      color: "var(--tamu-maroon)",
                      "&.Mui-checked": {
                        color: "var(--tamu-maroon)",
                      },
                    }}
                  />
                }
                label={
                  <Typography
                    sx={{ fontWeight: 600, fontSize: "18px", color: "#3E3E3E" }}
                  >
                    Add Home Address
                  </Typography>
                }
              />
            </Box>

            {includeAddress && (
              <>
                <Field
                  label="Street Address"
                  required
                  value={formData.homeAddressLine1}
                  onChange={handleChange("homeAddressLine1")}
                  error={errors.homeAddressLine1}
                />
                <Field
                  label="Apartment, Suite, etc."
                  required={false}
                  value={formData.homeAddressLine2}
                  onChange={handleChange("homeAddressLine2")}
                  error={errors.homeAddressLine2}
                />
                <Box sx={{ display: "flex", gap: 2 }}>
                  <Box sx={{ flex: 1 }}>
                    <Field
                      label="City"
                      required
                      value={formData.city}
                      onChange={handleChange("city")}
                      error={errors.city}
                    />
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "18px",
                        color: "#3E3E3E",
                        mb: "6px",
                      }}
                    >
                      State
                      <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                    </Typography>

                    <FormControl fullWidth error={!!errors.state}>
                      <Select
                        value={formData.state}
                        onChange={handleChange("state")}
                        displayEmpty
                        size="small"
                        sx={{
                          backgroundColor: "white",
                          borderRadius: "6px",
                        }}
                      >
                        <MenuItem value="">
                          <em>Select State</em>
                        </MenuItem>

                        {US_STATES.map((state) => (
                          <MenuItem key={state} value={state}>
                            {state}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    {errors.state && (
                      <Typography
                        sx={{
                          color: "#d32f2f",
                          fontSize: "12px",
                          mt: 0.5,
                        }}
                      >
                        {errors.state}
                      </Typography>
                    )}
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Field
                      label="Zip Code"
                      required
                      value={formData.zipCode}
                      onChange={handleChange("zipCode")}
                      error={errors.zipCode}
                    />
                  </Box>
                </Box>
              </>
            )}

            <Box sx={{ width: "250px" }}>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "18px",
                  color: "#3E3E3E",
                  mb: "6px",
                }}
              >
                Birth Date
                <span style={{ color: "red", marginLeft: "3px" }}>*</span>
              </Typography>
              <DatePicker
                value={
                  formData.birthDate
                    ? dayjs(formData.birthDate, "YYYY-MM-DD", true)
                    : null
                }
                onChange={(d) =>
                  setFormData((p) => ({
                    ...p,
                    birthDate: d && d.isValid() ? d.format("YYYY-MM-DD") : "",
                  }))
                }
                maxDate={dayjs()} // restrict future dates
                slotProps={{
                  textField: {
                    fullWidth: true,
                    error: !!errors.birthDate,
                    helperText: errors.birthDate,
                    variant: "outlined",
                    size: "small",
                    onPaste: handleBirthDatePaste,
                    sx: {
                      input: {
                        padding: "10px",
                        fontSize: "14px",
                        backgroundColor: "white",
                        borderRadius: "6px",
                      },
                      "& .MuiDataGrid-cell": {
                        paddingLeft: "12px",
                        paddingRight: "12px",
                        backgroundColor: "#FFFFFF",
                      },
                    },
                  },
                  popper: {
                    placement: "right-start",
                    modifiers: [
                      { name: "offset", options: { offset: [4, 4] } },
                      { name: "flip", enabled: false },
                    ],
                  },
                }}
                sx={{
                  "& .MuiPickersCalendarHeader-label": {
                    color: "var(--tamu-maroon)",
                    fontWeight: 600,
                    fontSize: "16px",
                  },
                  "& .MuiIconButton-root": {
                    color: "var(--tamu-maroon)",
                  },
                  "& .MuiPickersDay-root.Mui-selected": {
                    backgroundColor: "var(--tamu-maroon)",
                    color: "#fff",
                    border: "none",
                    outline: "none",
                  },
                  "& .MuiPickersDay-root:focus": {
                    outline: "none",
                  },
                }}
              />
            </Box>
          </Stack>
        </Box>
      </LocalizationProvider>
    </FocusedFlowPage>
  );
};

const Field = ({
  label,
  required,
  value,
  onChange,
  error,
  type = "text",
  placeholder,
  multiline,
  rows,
}) => (
  <Box>
    <Typography sx={{ fontWeight: 600, fontSize: "18px", color: "#3E3E3E" }}>
      {label}
      {required && <span style={{ color: "red", marginLeft: "3px" }}>*</span>}
    </Typography>
    <TextField
      fullWidth
      type={type}
      value={value}
      onChange={onChange}
      error={!!error}
      helperText={error}
      placeholder={placeholder}
      multiline={multiline}
      rows={rows}
      slotProps={{ inputLabel: { shrink: true } }}
      sx={{
        mt: "6px",
        input: {
          padding: "10px",
          fontSize: "18px",
          backgroundColor: "white",
          borderRadius: "6px",
        },
        textarea: {
          padding: "10px",
          fontSize: "18px",
          backgroundColor: "white",
          borderRadius: "6px",
        },
      }}
    />
  </Box>
);

export default AddPatientForm;
